import { unionBy } from 'lodash';
import {
  setServices,
  setTotalCount,
  setIsServicesLoading,
} from 'store/services/servicesReducer';
import { ThunkActionType } from 'store/store';
import { handleApiError } from 'store/app/appThunk';
import { IServiceWithAccountRequest } from 'interfaces/IUser';
import { getServicesApi } from 'services/api/servicesApi';

export const getServices = (
  data: IServiceWithAccountRequest,
  isSelect?: boolean,
): ThunkActionType => {
  return async (dispatch, getState) => {
    try {
      dispatch(setIsServicesLoading(true));
      const res = await getServicesApi(data);
      if (isSelect) {
        const { services } = getState().servicesReducer;

        dispatch(setServices(unionBy([
          ...services,
          ...res.content,
        ], 'serviceId')));
      } else {
        dispatch(setServices(res.content));
      }
      dispatch(setTotalCount(res.totalCount));
    } catch (err) {
      dispatch(handleApiError(err));
    } finally {
      dispatch(setIsServicesLoading(false));
    }
  };
};
